import ObjectParser from '@/utils/objectParser';

export class CustomOptionsServiceBase {
  _createDefaultParser() {
    return new ObjectParser().addBooleanParser('skip_select_service_button', {
      defaultValue: false,
    });
  }

  getOptions(options = {}) {
    return this._createDefaultParser().parse(options);
  }
}
